
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

export default {
name: 'login',
data() {
return {
disabled: true,
username: '', // 邮箱
password: '', // 密码
verifycode: '',
agreed: false,
reminderVisible: false,
selectVisible: false,
imgSrc: this.$api.validateCode,
userreminder:
'友情提醒：\n 1．本网站不采集涉及用户隐私的任何信息， 新用户注册用电子邮箱仅用于系统管理员在必要时发送联络信息。\n2．采用移动端设备进行注册的用户，请确认网络连接环境。通过拍摄(清晰、完整、无严重畸变)或调用保存的包装箱上的条形码进行产品型号和序列号的识别（自动上传），会因所用移动设备拍照性能的不同而产生一定的互联网流量。\n3.如系统无法准确识别实时扫码信息和条形码照片，建议访问松下系统专业产品官方网站prosystem.panasonic.cn，通过PC端手动填写方式进行注册。\n4.如系统已准确识别产品型号与序列号，但提示“没有找到匹配数据”，或在注册中有任何问题，请联系系统管理员。（电话010-65626796，电子邮箱PAVCS_helpdesk@cn.panasonic.com） \n5.设备保修资格确认后，相关数据将存储在广播电视系统产品保修信息管理系统中，用户可随时登录查询。同时，数据将定期传送到Panasonic系统通讯设备维修管理系统，我们不再提供纸质保修卡。 设备送修时，Panasonic认定维修站可以通过产品型号和序列号查看该设备的购买日期、保修有效性、保修特别条款等信息。',
remindermenus: {
'title.noop': this.userreminder,
delete: '<span style="color:red">Delete</span>'
}
}
},
methods: {
handleLogin() {
if (!this.username || !this.password) {
this.$vux.toast.text('您有未填项，不能登录')
} else {
let params = {
UserName: this.username,
Password: this.password,
VerifyCode: this.verifycode
}
let that = this
this.$api
.login(params)
.then(res => {
if (res.Status === 1) {
sessionStorage.setItem('token', res.Entity)
sessionStorage.setItem('user', this.username)

that.selectVisible = true
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
that.refreshCode()
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络出错，无法登录！'
})

that.refreshCode()
})
}
},
openRemind() {
this.selectVisible = false
this.reminderVisible = true
},
toHome() {
this.remindVisible = false
this.$router.push({ path: '/mobile/home' })
},
toRepairHome() {
this.selectVisible = false
this.$router.push({ path: '/mobile/repairhome' })
},
keyDown() {
if (
this.$refs.refusername.valid === true &&
this.$refs.refpassword.valid === true &&
this.$refs.refverifycode.valid === true
) {
this.disabled = false
} else {
this.disabled = true
}
},
refreshCode() {
let src = this.imgSrc
this.imgSrc = ''
this.$nextTick(() => {
this.imgSrc = src + '?'
})
}
},
created() {
window.document.title = '登录'
},
components: {
XInput,
XButton,
Flexbox,
FlexboxItem,
Group,
Box,
XHeader,
InlineXSwitch,
Popup,
XTextarea,
CheckIcon
}
}



// WEBPACK FOOTER //
// ./src/mobile/Login.vue